<template>
  <div class="proveedores-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :documentoNumero="documentoNumero"
          :provincia="provincia"
          :localidad="localidad"
          :promedioEvaluacionesMin="promedioEvaluacionesMin"
          :promedioEvaluacionesMax="promedioEvaluacionesMax"
          :etiqueta="etiqueta"
          :categoria="categoria"
          :incluirInactivos="incluirInactivos"
          :labelCols="2"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Proveedores">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="proveedores" 
              :fields="proveedorFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(promedioEvaluaciones)="data">
              <app-rating
                v-if="data.item.cantidadEvaluaciones != 0"
                :calificacion="data.item.promedioEvaluaciones">
              </app-rating>
            </template>
            <template v-slot:cell(cantidadEvaluaciones)="data">
              {{ data.item.cantidadEvaluaciones | numero }}
            </template>
            <template v-slot:cell(fechaUltimaEvaluacion)="data">
              {{ data.item.fechaUltimaEvaluacion | fecha }}
            </template>
            <template v-slot:cell(inactivo)="data">
              {{ (data.item.inactivo) ? 'Si' : 'No' }}
            </template>

            <template v-slot:cell(opciones)="data" v-if="accesoEdit">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Proveedor</b-dropdown-item>
                <!--
                <b-dropdown-item @click.stop="borrar(data.item)">
                  <i class="fa fa-remove"></i>Borrar</b-dropdown-item>
                -->
              </b-dropdown>
            </template>

            <template v-slot:cell(detailShowing)="row">
              <b-btn class="detailShowing" 
                  size="sm" 
                  v-if="row.item.etiquetas.length != 0" 
                  @click.stop="row.toggleDetails">
                {{ ( row.detailsShowing) ? '-' : '+' }}
              </b-btn>            
            </template>

            <template v-slot:row-details="row">
              <b-row>
                <b-col cols="12">
                  <template  v-for="{ id, nombre } in row.item.etiquetas">
                    <b-badge :key="id" variant="primary">
                      {{ nombre }}
                      <!-- <i class="fa fa-times" @click="borrarEtiqueta(id)"></i> -->
                    </b-badge>                      
                  </template>  
                </b-col>
              </b-row>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
              <label class="pagination-description">{{ paginacion }}</label>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <!-- <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div> -->

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item 
              v-if="accesoAdd"
              @click.stop="agregar">
            <i class="fa fa-plus"></i>Nuevo Proveedor</b-dropdown-item>
          <b-dropdown-item
              @click.stop="exportXls">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Proveedores</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Rating from  '../shared/rating.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'proveedores/getField',
  mutationType: 'proveedores/updateField',
});

export default {
  name: 'ProveedoresList',
  components: {
    appFiltro: Filtro,
    appRating: Rating,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      proveedorFields: [
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        {
          key: 'nombreComercial',
          sortable: true
        },
        {
          key: 'razonSocial',
          sortable: true
        },
        { 
          key: 'promedioEvaluaciones',
          label: 'Calificación',
          // class: 'text-right', 
        },
        { 
          key: 'categoria',
          label: 'Categoría',
          class: 'text-center' 
        },
        { 
          key: 'cantidadEvaluaciones',
          label: 'Evaluaciones',
          class: 'text-right', 
        },
        { 
          key: 'fechaUltimaEvaluacion',
          label: 'Últ.Evaluación'
        },
        { 
          key: 'inactivo',
          class: 'text-center', 
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
      accesoAdd: false,
      accesoEdit: false
    }
  },
  computed: {
    ...mapFields([
      'proveedores',
      'nombre',
      'documentoNumero',
      'provincia',
      'localidad',
      'promedioEvaluacionesMin',
      'promedioEvaluacionesMax',
      'etiqueta',
      'categoria',
      'incluirInactivos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
    paginacion() {
      let paginaActual = 0;
      let registrosPorPagina = 0;
      let totalPaginas = 0;
      let totalRegistros = 0;
      let registroDesde = 0;
      let registroHasta = 0;

      if (this.paginaActual) {
        if (!isNaN(this.paginaActual)) {
          paginaActual = parseInt(this.paginaActual);
        }
      }
      if (this.registrosPorPagina) {
        if (!isNaN(this.registrosPorPagina)) {
          registrosPorPagina = parseInt(this.registrosPorPagina);
        }
      }
      if (this.totalPaginas) {
        if (!isNaN(this.totalPaginas)) {
          totalPaginas = parseInt(this.totalPaginas);
        }
      }
      if (this.totalRegistros) {
        if (!isNaN(this.totalRegistros)) {
          totalRegistros = parseInt(this.totalRegistros);
        }
      }
      if (totalPaginas == 0) {
        totalPaginas = 1;
      }
      registroDesde = ((paginaActual - 1) * registrosPorPagina) + 1;
      if (registroDesde > totalRegistros) {
        registroDesde = totalRegistros;
      }
      registroHasta = registroDesde + registrosPorPagina - 1;
      if (registroHasta > totalRegistros) {
        registroHasta = totalRegistros;
      }

      return `Pág. ${paginaActual} de ${totalPaginas} - Registros ${registroDesde} a ${registroHasta} de ${totalRegistros} registros`;
    }
  },
  created() {
    let route = this.$router.resolve({ name: 'ProveedorAdd' }).route;
    this.accesoAdd = Boolean(this.$store.getters['user/tieneAcceso'](route));
    route = this.$router.resolve({ name: 'ProveedorEdit', params: { 'id': -1 } }).route;
    this.accesoEdit = Boolean(this.$store.getters['user/tieneAcceso'](route));

    this.getProveedores();
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.documentoNumero = filtro.documentoNumero;
      this.provincia = filtro.provincia;
      this.localidad = filtro.localidad;
      this.promedioEvaluacionesMin = filtro.promedioEvaluacionesMin;
      this.promedioEvaluacionesMax = filtro.promedioEvaluacionesMax;
      this.etiqueta = filtro.etiqueta;
      this.categoria = filtro.categoria;
      this.incluirInactivos = filtro.incluirInactivos;
      this.paginaActual = 1;

      this.getProveedores();
    },
    getProveedores() {
      this.tableBusy = true;
      this.$store.dispatch('proveedores/getProveedores')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'ProveedorDatos', 
                          params: { id: item.id }})
    },
    editar (item) {
      if (this.accesoEdit) {
        this.$router.push({ name: 'ProveedorEdit', 
                            params: { id: item.id }})
      }
    },
    borrar (item) {
      this.showModalMsj('Esta opción no se encuentra disponible', null, null, 'light');
    },
    agregar () {
      if (this.accesoAdd) {
        this.$router.push({ name: 'ProveedorAdd' })
      }
    },
    exportXls () {
      let params = {
        nombre: this.nombre,
        documentoNumero: this.documentoNumero,
        provincia: this.provincia,
        localidad: this.localidad,
        promedioEvaluacionesMin: this.promedioEvaluacionesMin,
        promedioEvaluacionesMax: this.promedioEvaluacionesMax,
        etiqueta: this.etiqueta,
        categoria: this.categoria,
        incluirInactivos: this.incluirInactivos
      }

      this.showSpinner();
      this.$store.dispatch('proveedores/getRptProveedores', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptProveedores = this.$store.getters['proveedores/rptProveedores'];

          if (rptProveedores) {
            if (rptProveedores.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {

            let title= 'Listado de Proveedores';
            let fileName = 'proveedores';
            let format = [
              { titulo: 'Código', nombre: 'id', formato: '' },
              { titulo: 'Razón Social', nombre: 'razonSocial', formato: '' },
              { titulo: 'Nombre Comercial', nombre: 'nombreComercial', formato: '' },
              // { titulo: 'Pais', nombre: 'pais', formato: '' },
              // { titulo: 'Provincia', nombre: 'provincia', formato: '' },
              // { titulo: 'Localidad', nombre: 'localidad', formato: '' },
              { titulo: 'Inactivo', nombre: 'inactivo', formato: 'bool' }
            ];

            this.exportXLS(title, fileName, rptProveedores, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getProveedores() 
      }
    },    
  }    
}
</script>

<style>
  .proveedores-list table td {
    padding-top: 5px;
    padding-bottom: 5px;
    vertical-align: middle;
  }
  .proveedores-list table .b-table-details td {
    padding-top: 0;
    padding-left: 50px;
  }

  .proveedores-list table td[aria-colindex="1"] {
    width: 30px;
  }
  .proveedores-list table td[aria-colindex="2"] {
    width: calc(30% - 30px);
  }
  .proveedores-list table td[aria-colindex="3"] {
    width: calc(27% - 30px);
  }
  .proveedores-list table td[aria-colindex="4"] {
    width: 12%;
  }
  .proveedores-list table td[aria-colindex="5"] {
    width: 8%;
  }
  .proveedores-list table td[aria-colindex="6"] {
    width: 8%;
  }
  .proveedores-list table td[aria-colindex="7"] {
    width: 10%;
  }
  .proveedores-list table td[aria-colindex="8"] {
    width: 5%;
  }
  .proveedores-list table td[aria-colindex="9"] {
    width: 30px;
  }

  .proveedores-list .rating .star {
    margin-right: 5px;
  }

  .proveedores-list .badge {
    padding: 5px 12px;
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .proveedores-list .badge i {
    margin-left: 5px;
    cursor: pointer;
  }

</style>
